export default __webpack_public_path__ + "static/media/latvia.76ae49b0.svg";